/**
 * region for libraries*/
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ContainerRouter from './ContainerRouter';

/**
 * region for custom modules*/
import './index.css';
import * as serviceWorker from './serviceWorker';

/*Redux */
import { Provider } from 'react-redux';
import { store } from './store'


/**
 * region for authentification*/
import AuthService from './services/AuthService';

/**
 * region for styles*/
import './asset/css/bootstrap.css';
import './asset/css/style.css';
import './asset/css/App.css';
import './asset/css/styleMaterialUI.css';
import './asset/css/tailwind.css';

require('dotenv').config();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


/**
 * region for consts and variables*/
const auth = new AuthService();
const rootElement = document.getElementById('root');
let urlParams = new URLSearchParams(document.location.search);
let loginToken = urlParams.get('token');

if (auth.loggedIn()) {
    ReactDOM.render(
        <Provider store={store}>
            <ContainerRouter />
        </Provider>,
        rootElement);
        serviceWorker.register();
}
else {
    if (loginToken) {
        auth.login(loginToken, function () {
            ReactDOM.render(
                <Provider store={store}>
                    <ContainerRouter />
                </Provider>,
                rootElement);
        });
        serviceWorker.register();
    }
}